import { FC } from "react"
import { v4 as uuidv4 } from 'uuid';

const TableLoadingAnimation: FC<{}> = () => {
    return (
        <>
            <div className="container" key={uuidv4()}>
                <div className="column">
                    <div className="line line4 loading-animation"></div>
                </div>
            </div>
        </>
    )
}

export default TableLoadingAnimation
